import { render, staticRenderFns } from "./BossIndex.vue?vue&type=template&id=1eec58a5&scoped=true&"
import script from "./BossIndex.vue?vue&type=script&lang=js&"
export * from "./BossIndex.vue?vue&type=script&lang=js&"
import style0 from "./BossIndex.vue?vue&type=style&index=0&id=1eec58a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eec58a5",
  null
  
)

export default component.exports